import axios from "axios";
import accessToken from "./jwt-token-access/accessToken";

// Pass new generated access token here
const authUser = JSON.parse(localStorage.getItem("authUser"));
const LocalToken = authUser ? authUser.token : '';

const token = `${LocalToken || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzQ3MTMwMjExLCJpYXQiOjE3MTU1OTQyMTEsImp0aSI6IjdmZTg4ZDA5NDAxZDQ3ZWVhYzU3NDc0MmM1ODRhNGNlIiwidXNlcl9pZCI6Njh9.OTKGLBSL_xphd1mScqeZ1cnocMii73od8qfuUn-3FxE"}`
console.log(LocalToken, "LocalToken")
// Apply base URL for axios
const API_URL = "https://api.llosana.com/api/";

const axiosApi = axios.create({
  baseURL: API_URL,
});

// Set Authorization header with the token
if (LocalToken) {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
);

export async function get(url, config = {}) {
  return await axiosApi.get(`${API_URL}${url}`, { ...config }).then(response => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi.post(`${API_URL}${url}`, { ...data }, { ...config }).then(response => response);
}

export async function put(url, data, config = {}) {
  return axiosApi.put(url, { ...data }, { ...config }).then(response => response);
}

export async function patch(url, data, config = {}) {
  return axiosApi.patch(url, { ...data }, { ...config }).then(response => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi.delete(`${API_URL}${url}`, { ...config }).then(response => response);
}
